import { translate } from '@/core/services/translation-service'
import { formatDate } from '@/core/utils'

export default {
  methods: {
    formatDate,
    translate
  }
}
